import { render, staticRenderFns } from "./driver_page.vue?vue&type=template&id=1de40a17&scoped=true"
import script from "./driver_page.vue?vue&type=script&lang=js"
export * from "./driver_page.vue?vue&type=script&lang=js"
import style0 from "./driver_page.vue?vue&type=style&index=0&id=1de40a17&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de40a17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de40a17')) {
      api.createRecord('1de40a17', component.options)
    } else {
      api.reload('1de40a17', component.options)
    }
    module.hot.accept("./driver_page.vue?vue&type=template&id=1de40a17&scoped=true", function () {
      api.rerender('1de40a17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/car_team/driver_page.vue"
export default component.exports